import React from 'react';
import Router from '../Router/Router';

export default function Content() {
  return <Router />;
}
